import { useContext } from 'react';
import Image from '@next/image';

import Message from 'types/Message';
import { FilesContext } from '@providers/FilesProvider';
import Typography from '@components/atoms/Typography';

import classes from './EducationHeroSection.module.scss';

export type Props = {
  title: Message;
  subtitle: Message;
};

const EducationHeroSection = ({ title, subtitle }: Props): JSX.Element => {
  const { getPageImageConfigs } = useContext(FilesContext);
  const [background, logo] = getPageImageConfigs(['background', 'logo']);

  return (
    <section className={classes.wrapper}>
      <div className={classes.container}>
        {logo && <Image alt="background" width={295} resolveConfig={logo} hasLazyLoad={false} hasPreload />}
        <div>
          <Typography className={classes.title} variant="h1">
            {title}
          </Typography>
          <Typography className={classes.subtitle} variant="body1" renderAs="div">
            {subtitle}
          </Typography>
        </div>
      </div>
      {background && (
        <Image
          alt="background"
          layout="fill"
          objectFit="cover"
          className={classes.image}
          resolveConfig={background}
          hasLazyLoad={false}
          hasPreload
        />
      )}
    </section>
  );
};

export default EducationHeroSection;
